import {
    getSessionFromLocalStorage,
    httpRawClient,
    setSessionRestore,
    setSessionToLocalStorage,
    type TSession,
} from '@core/http-client'
import { Logger } from '@core/logger'

const NEXT_AUTH_SESSION_URL = '/api/auth/session'

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null

const isNextAuthSession = (value: unknown): value is TSession =>
    isRecord(value) &&
    isRecord(value.user) &&
    isRecord(value.token) &&
    typeof value.token.tokenType === 'string' &&
    typeof value.token.accessToken === 'string'

const loadNextAuthSession = async (): Promise<void> => {
    try {
        const session = await httpRawClient.get(NEXT_AUTH_SESSION_URL).json<unknown>()

        if (isNextAuthSession(session)) {
            setSessionToLocalStorage(session)
        }
    } catch (error) {
        Logger.error('GET api/auth/session error:', { error })
    }
}

export const restoreSession = (userId: number) => {
    if (userId === 0 || getSessionFromLocalStorage()) {
        return
    }

    setSessionRestore(loadNextAuthSession())
}
